export default function BrandMark({ size = 28 }) {
  // Inline-SVG monogram so the brand mark renders without a network
  // request and inherits the gradient defined in global.css.
  return (
    <div className="row" style={{ gap: 8, alignItems: 'center' }}>
      <svg width={size} height={size} viewBox="0 0 40 40" aria-label="Outglow.Live">
        <defs>
          <linearGradient id="og-grad" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#FF3E7F" />
            <stop offset="50%" stopColor="#FF6B4A" />
            <stop offset="100%" stopColor="#FFB347" />
          </linearGradient>
        </defs>
        <circle cx="20" cy="20" r="18" fill="url(#og-grad)" />
        <path
          d="M14 14 L26 14 L20 22 L24 26 L16 26 Z"
          fill="#08060E"
        />
      </svg>
      <span style={{
        fontFamily: 'var(--font-display)',
        fontWeight: 700,
        fontSize: Math.max(16, size * 0.7),
        letterSpacing: -0.6,
        color: 'var(--text)'
      }}>
        Outglow
      </span>
    </div>
  );
}
